<style scoped>
.meeting-box {
  margin: 16px 10px;
  padding: 5px 20px;
  background: #fff;
  border-radius: 4px;
  text-align: left;
}
.meeting-subject {
  font-size: 20px;
  /* font-weight: bold; */
}
.information-box {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}
.information-list {
  /* width: 33%; */
}
.state-now {
  border: 1px solid grey;
}
.now-state {
  font-size: 14px;
  padding: 5px 30px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid grey;
}
.video-url {
  color: #4fa1a4;
  margin-left: 15px;
  text-decoration: underline;
  cursor: pointer;
}
</style>
<template>
  <div class="meeting-detail pb30">
    <div class="meeting-box">
      <p class="meeting-subject">
        会议主题：{{ onlineDetail.meetingSubject }} <span class="ml30 fontC-red">{{ $route.query.meetingState }}</span
        ><span class="now-state state-back fr" @click="$router.go(-1)">返回</span>
      </p>
      <p class="font-S16">所属公司：{{ $route.query.tenantName }}</p>
    </div>
    <div class="meeting-box">
      <p class="font-S16">基本信息</p>
      <div class="information-box">
        <div class="information-list">
          <p><span class="fontC-bbb">会议发起人：</span>{{ onlineDetail.staffName }}</p>
          <p><span class="fontC-bbb">会议开始时间：</span>{{ onlineDetail.startTime | getTime }}</p>
          <p>
            <span class="fontC-bbb">安全级别：</span><span v-if="onlineDetail.safeLevel == 1">低（无限制）</span
            ><span v-if="onlineDetail.safeLevel == 2">中（参会人需输入密码、短信验证）</span
            ><span v-if="onlineDetail.safeLevel == 3">高（参会人需输入密码、短信验证、无法下载会议）</span>
            <span v-if="!onlineDetail.safeLevel">-</span>
          </p>
          <p>
            <span class="fontC-bbb" v-if="onlineDetail.meetingAddress">会议地点：</span
            ><span>{{ onlineDetail.meetingAddress }}</span>
          </p>
          <p>
            <span class="fontC-bbb" v-if="onlineDetail.serviceCompany">推广服务商：</span
            ><span>{{ onlineDetail.serviceCompany }}</span>
          </p>
        </div>
        <div class="information-list w25f">
          <p><span class="fontC-bbb">提交日期：</span>{{ onlineDetail.createTime | getTime }}</p>
          <p><span class="fontC-bbb">会议结束时间：</span>{{ onlineDetail.endTime | getTime }}</p>
          <p><span class="fontC-bbb">会议负责人：</span>{{ onlineDetail.leader }} - {{ onlineDetail.leaderMobileNo }}</p>
          <p>
            <span class="fontC-bbb">会议费用：</span
            ><span>{{ onlineDetail.meetingCost || 0}}</span>
          </p>
        </div>
        <div class="information-list">
          <p>
            <span class="fontC-bbb">会议类型：</span
            ><span v-if="onlineDetail.meetingType == 1">小型（单讲者会议 + 会议50人以内）</span
            ><span v-if="onlineDetail.meetingType == 2">中型（单讲者会议 + 会议100人以内）</span
            ><span v-if="onlineDetail.meetingType == 3">大型（多讲者会议 + 会议100人以上）</span>
            <span v-if="$route.query.isMeetingApply == 'N'">{{onlineDetail.meetingType}}</span>
          </p>
          <p><span class="fontC-bbb">会议时长：</span>{{ $route.query.meetingTimeLong+'分钟' || '-' }}</p>
          <p>
            <span class="fontC-bbb">参会人数：</span
            >{{
              onlineDetail.peopleNum !== 0 && onlineDetail.peopleNum !== '' && onlineDetail.peopleNum !== null
                ? onlineDetail.peopleNum
                : '-'
            }}
          </p>
          <p>
            <span class="fontC-bbb" v-if="onlineDetail.serviceStaff">推广服务人员：</span
            ><span>{{ onlineDetail.serviceStaff }}</span>
          </p>
        </div>
      </div>
    </div>

    <div class="meeting-box" v-if="onlineDetail.meetingPlan">
      <p class="font-S16">会议方案</p>
      <p>{{ caCodeToDesc(onlineDetail.meetingPlan) }}</p>
    </div>
    <div class="meeting-box" v-if="onlineDetail.meetingAgenda">
      <p class="font-S16">会议议程</p>
      <p>{{ onlineDetail.meetingAgenda }}</p>
    </div>
    <div class="meeting-box" v-if="onlineDetail.meetingPrupose">
      <p class="font-S16">会议目的</p>
      <p>{{ onlineDetail.meetingPrupose }}</p>
    </div>
    <div class="meeting-box" v-if="onlineDetail.desiredResult">
      <p class="font-S16">预期效果</p>
      <p>{{ onlineDetail.desiredResult }}</p>
    </div>
    <div class="meeting-box" v-if="onlineDetail.speakerIntroduction">
      <p class="font-S16">讲者介绍</p>
      <p>{{ onlineDetail.speakerIntroduction }}</p>
    </div>
    <div class="meeting-box pb20">
      <p class="font-S16">会议信息</p>
      <p>
        <template v-if="$route.query.isMeetingApply =='N'&&onlineDetail.meetingUrl">
          <span class="fontC-bbb">链接： </span>{{ onlineDetail.meetingUrl }}
          <span @click="toLink(onlineDetail.meetingUrl)" class="video-url">查看</span>
        </template>
        <template v-if="$route.query.isMeetingApply =='Y'&&onlineDetail.videoUrl"
          ><span class="fontC-bbb">腾讯链接：</span>{{ onlineDetail.videoUrl }}
          <span @click="toLink(onlineDetail.videoUrl)" class="video-url">查看会议视频</span>
        </template>
      </p>
      <div class="information-box">
        <div class="information-list w30f">
          <span class="fontC-bbb">客服热线：</span>{{ onlineDetail.servicePhone || '-'}}
        </div>
        <div class="information-list w70f">
          <span class="fontC-bbb">实际参会人数：</span>{{ onlineDetail.realJoinNum || 0}} 人
        </div>
      </div>
    </div>
    <div class="meeting-box" v-if="billList && billList.length != 0">
      <p class="font-S16">会议海报/邀请函照片</p>
      <el-image
        v-for="(item, index) in billList"
        :key="index"
        style="width: 100px; height: 100px; margin-right: 20px"
        :src="item"
        :preview-src-list="billList"
      >
      </el-image>
      <p class="fontC-bbb" v-if="billList == null || billList == ''">暂无图片</p>
    </div>
    <div class="meeting-box" v-if="imgList && imgList.length != 0">
      <p class="font-S16">会议照片</p>
      <el-image
        v-for="(item, index) in imgList"
        :key="index"
        style="width: 100px; height: 100px; margin-right: 20px"
        :src="item"
        :preview-src-list="imgList"
      >
      </el-image>
      <p class="fontC-bbb" v-if="imgList == null || imgList == ''">暂无图片</p>
    </div>
    <div class="meeting-box" v-if="signList && signList.length != 0">
      <p class="font-S16">签到表</p>
      <el-image
        v-for="(item, index) in signList"
        :key="index"
        style="width: 100px; height: 100px; margin-right: 20px"
        :src="item"
        :preview-src-list="signList"
      >
      </el-image>
      <p class="fontC-bbb" v-if="signList == null || signList == ''">暂无图片</p>
    </div>
    <div class="meeting-box" v-if="meetingReport && meetingReport.length != 0">
      <p class="font-S16">会议报告</p>
      <el-image
        v-for="(item, index) in meetingReport"
        :key="index"
        style="width: 100px; height: 100px; margin-right: 20px"
        :src="item"
        :preview-src-list="meetingReport"
      >
      </el-image>
      <p class="fontC-bbb" v-if="meetingReport == null || meetingReport == ''">暂无图片</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      onlineDetail: '',
      approvalSuggest: '',
      flowName: '线上会议执行2',
      carbonName: '',
      approvalList: [],
      approverGuid: '',
      staffGuid: '',
      billList: [], //海报
      imgList: [], //照片
      signList: [], //签到表
      meetingReport: [], //报告
      url: '',
      tenantName: '',
      flowType: '00002',
      meetingPlanList: [], //方案
    };
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.staffGuid = userinfo.staffGuid;
    this.getMeetingCaList();
  },
  methods: {
    getMeetingCaList() {
      var self = this;
      var page = {
        pageIndex: 1,
        pageSize: -1,
        isOpen: '-1',
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/plan/get-list`, page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.meetingPlanList = res.data.data.records;
          self.getData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    caCodeToDesc(listStr) {
      var list = [];
      if (listStr != '') {
        list = JSON.parse(listStr);
        return list.join('；');
      }
    },
    toLink(url) {
      window.open(url);
    },
    getData() {
      let self = this;
      self.api
        .postCan(
          `/${serverConfig.msSalesPerformService}/flow/data/get-online-meeting-detail?guid=` + self.$route.query.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.onlineDetail = res.data.data;
            self.billList = [];
            self.imgList = [];
            self.signList = [];
            self.meetingReport = [];
            if (res.data.data.meetingBill !== null) {
              let meetingBill = JSON.parse(res.data.data.meetingBill);
              meetingBill.forEach((item) => {
                self.billList.push(item.path);
              });
              console.log(self.imgList);
            }
            if (res.data.data.meetingPhoto !== null) {
              let meetingPhoto = JSON.parse(res.data.data.meetingPhoto);
              meetingPhoto.forEach((item) => {
                self.imgList.push(item.path);
              });
              console.log(self.imgList);
            }
            if (res.data.data.signFile !== null) {
              let signFile = JSON.parse(res.data.data.signFile);
              signFile.forEach((item) => {
                self.signList.push(item.path);
              });
              console.log(self.signList);
            }
            if (res.data.data.meetingReport != null) {
              let meetingReport = JSON.parse(res.data.data.meetingReport);
              meetingReport.forEach((item) => {
                self.meetingReport.push(item.path);
              });
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
  },
};
</script>
